import React from "react";

import { getTodosClienteServicosFinanceiros } from "../../../services/cliente";
import { obterDadosUsuario2, guardarDadosUsuario2 } from "../../../services/cookies";
import { obterTodosClientes } from "../../../services/gestor";
import { renovacaoToken } from "../../../services/usuario";

export interface Cliente {
  nome: string;
  idCredenciais: string;
  email: string;
}

const obterListasDeClientes = async (token: string) => {
  const [clientesResponse, privatesResponse] = await Promise.all([
    obterTodosClientes(token),
    getTodosClienteServicosFinanceiros(token, 3, 1, 1000),
  ]);

  return {
    clientes: clientesResponse.data?.resultado?.clientes || [],
    privates: privatesResponse.data?.resultado?.clientes || [],
  };
};

export const obterClientes = async (
  setListaClientes: React.Dispatch<Cliente[]>,
  setListaPrivates: React.Dispatch<Cliente[]>,
  setLoading: React.Dispatch<boolean>,
  setErro: React.Dispatch<boolean>,
  setDesconectar: React.Dispatch<boolean>
) => {
  setLoading(true);
  setErro(false);

  const { email, urlAvatar, id, token, tokenRenovacao } = obterDadosUsuario2();

  try {
    const { clientes, privates } = await obterListasDeClientes(token);
    setListaClientes(clientes);
    setListaPrivates(privates);
  } catch (err) {
    const status = (err as any)?.response?.status;
    const message = String(err);

    if (status === 401 || message === "Error: Request failed with status code 401") {
      try {
        const res = await renovacaoToken(token, tokenRenovacao);
        const tokenAcesso = res.data.camposAdicionais.tokenAcesso;

        guardarDadosUsuario2(
          tokenAcesso,
          res.data.camposAdicionais.tokenRenovacao,
          email.toString(),
          id.toString(),
          urlAvatar
        );

        const { clientes, privates } = await obterListasDeClientes(tokenAcesso);
        setListaClientes(clientes);
        setListaPrivates(privates);
      } catch {
        setDesconectar(true);
      }
    } else {
      setErro(true);
    }
  } finally {
    setLoading(false);
  }
};
